import { AssetManager } from "./AssetManager";
import { ASSET_TYPE, BearAsset } from "../AssetConst";
import * as THREE from "three";

import { PlaneUtils } from "../PlaneUtils";
import { VideoAssetManager } from "@/argo_ar/argo_webar_lib/VideoAssetManager";
import { BuildMediaUrl, getGifPit, getPit } from "../../ArgoUtils";
import SuperGif from "../supergif/super-gif.js";

export class PlanarAssetManager extends AssetManager {
    private planeUtils: PlaneUtils = new PlaneUtils();
    private videoAssetManager: VideoAssetManager = new VideoAssetManager();
    private audioVideoPit: HTMLElement;

    public getComputedAsset = (asset: BearAsset): Promise<THREE.Mesh> => {
        this.audioVideoPit = getPit();
        const assetCoords = this.fnGetAssetRealCoords(asset);

        return new Promise(resolve => {
            let geometry = new THREE.PlaneGeometry(1, 1);
            let material = new THREE.MeshBasicMaterial({
                side: THREE.DoubleSide,
                depthWrite: true,
                depthTest: true,
                alphaTest: 0.5,
                transparent: true
            });
            let texture;
            let plane, videoPlane;
            let s1 = asset.s1;
            let url: string;

            if (asset.custom_image && "" != asset.custom_image) url = asset.custom_image;
            else if (asset.custom_image_media && "" != asset.custom_image_media)
                url = asset.custom_image_media;
            else if (asset.media_custom_image && "" != asset.media_custom_image)
                url = asset.media_custom_image;
            s1 = asset.s1 && asset.s1 != "" ? asset.s1 : asset.media_file;

            if (asset.asset_type == ASSET_TYPE.VIDEO) {
                const videoUrl = BuildMediaUrl(s1);
                videoPlane = this.videoAssetManager.addVideoPlane(
                    asset,
                    videoUrl,
                    this._markerWidth,
                    this._markerHeight,
                    assetCoords,
                    this.audioVideoPit
                );

                if (asset.autoplay_on_texture || url == undefined || url == null) {
                    resolve(videoPlane);
                    return;
                }
            }

            if (asset.asset_type == ASSET_TYPE.AUDIO) {
                this.videoAssetManager.addAudioOnAsset(
                    asset,
                    BuildMediaUrl(s1),
                    this.audioVideoPit
                );
            }

            // we check if this is an animated GIF or a static image
            const ext = url
                ? url
                      .split(".")
                      .pop()
                      .toLowerCase()
                      .split("?")[0]
                : "";
            // if GIF takes too much memory it may be worth it to
            // compare with webassembly performance
            if (ext == "gif") {
                const domElement = document.createElement("img");
                domElement.setAttribute("src", BuildMediaUrl(url));
                const id = "threegif-" + asset.id;
                domElement.setAttribute("id", id);

                getGifPit().appendChild(domElement);

                const supGif = new SuperGif(document.getElementById(id), {});
                supGif.load(gif => {
                    const gifCanvas = supGif.canvas;
                    //new method
                    material.map = new THREE.Texture(gifCanvas);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    //@ts-ignore
                    material.displacementMap = material.map;
                    supGif.material = material;
                    //end new method

                    plane = new THREE.Mesh(geometry, material);
                    plane.scale.set(assetCoords.width, assetCoords.height, 1);
                    plane.needsUpdate = true;
                    //we save the gif because we may want to pause it later on
                    plane.gif = supGif;
                    this.planeUtils.fnCreatePlane(
                        plane,
                        asset,
                        assetCoords,
                        this._markerWidth,
                        this._markerHeight
                    );
                    //michael
                    domElement.style.display = "none";
                    gifCanvas.style.display = "none";

                    this.attachVideoPlaneToImgPlane(videoPlane, plane);
                    resolve(plane);
                });
            } else if (url) {
                if (ext == "png") {
                    material = new THREE.MeshBasicMaterial({
                        map: texture,
                        transparent: false,
                        alphaTest: 0.5,
                        opacity: 1,
                        side: THREE.DoubleSide
                    });
                }
                texture = new THREE.TextureLoader().load(BuildMediaUrl(url));
                material.map = texture;
                plane = new THREE.Mesh(geometry, material);
                plane.scale.set(assetCoords.width, assetCoords.height, 1);
                this.planeUtils.fnCreatePlane(
                    plane,
                    asset,
                    assetCoords,
                    this._markerWidth,
                    this._markerHeight
                );

                this.attachVideoPlaneToImgPlane(videoPlane, plane);
                resolve(plane);
            } else {
                //create transparentPlane
                geometry = new THREE.PlaneGeometry(1, 1);
                material = new THREE.MeshBasicMaterial({
                    color: 0xff0000,
                    opacity: 0.0,
                    transparent: true
                });
                plane = new THREE.Mesh(geometry, material);
                plane.scale.set(assetCoords.width, assetCoords.height, 1);
                this.planeUtils.fnCreatePlane(
                    plane,
                    asset,
                    assetCoords,
                    this._markerWidth,
                    this._markerHeight
                );
                plane.visible = true; //for

                this.attachVideoPlaneToImgPlane(videoPlane, plane);
                resolve(plane);
            }
        });
    };

    /**
     *
     * @param videoPlane
     * @param plane
     * Small helper, we need 2 planes for video : one for img, one for video
     */
    attachVideoPlaneToImgPlane(videoPlane, plane) {
        if (videoPlane != undefined) {
            plane.videoPlane = videoPlane;
            plane.attach(videoPlane);
            videoPlane.visible = false;
        }
    }

    /**
     * @param {object} coords coords to use
     * @param {object} img image object (alreay loaded)
     * create plane with icon drawn on it
     */
    /*    fnCreateEmptyAssetIcon(coords, img)
       {
           let canvas			= document.createElement('canvas');
    
           let ratio			= coords.width > coords.height ? coords.width / coords.height : coords.height / coords.width;
           canvas.width		= coords.width > coords.height ? 1024 : 1024 / ratio;
           canvas.height		= coords.width > coords.height ? 1024 / ratio : 1024;
           let ctx				= canvas.getContext('2d');
           ctx.fillStyle		= "#f6f6f6";
           let iconWidth		= (canvas.width > canvas.height ? canvas.height : canvas.width) * 0.5;
           let iconHeight		= iconWidth;
           let texture			= new THREE.Texture(canvas);
           texture.needsUpdate = true;
           let geometry		= new THREE.PlaneGeometry(1, 1);
           let material		= new THREE.MeshBasicMaterial({
               map:texture,
               opacity:1,
               overdraw : 1,
               side:THREE.DoubleSide,
               depthWrite: true,
               depthTest: true,
               alphaTest: 0,
               transparent:false,
           });
    
           ctx.fillRect(0,0,canvas.width,canvas.height);
           ctx.drawImage(img,canvas.width/2-iconWidth/2,canvas.height/2-iconHeight/2, iconWidth, iconHeight);
    
           let plane		= new THREE.Mesh(geometry, material);
           plane.scale.set(coords.width, coords.height, 1);
           plane.icon		= img;
           plane.canvas	= canvas;
           return plane;
       } */

    /**
     * @param {object} asset asset as given by the api
     * return promise of asset mesh
     */

    /*    fnCreatePlaceholderAsset(asset : BearAsset, texture : Texture)
       {
           const self = this;
           if(asset.sId==sceneComponent.instance.sId){
               let coords = self.fnGetAssetRealCoords(asset.x, asset.y, asset.width, asset.height);
               let fAlt;
               
               fAlt = asset.zorder * 0.001;
               coords.z = fAlt;
    
               let material = new THREE.MeshBasicMaterial( { map: texture,
                       side:THREE.DoubleSide,
                       depthWrite: true,
                       depthTest: true,
                       alphaTest: 0.5,
                       transparent: true} );
               let geometry = new THREE.PlaneGeometry(0.1, 0.1);
               let plane = new THREE.Mesh( geometry, material );
    
               plane.position.set(coords.x  - (this.fMarkerWidth/2) + (coords.width/2), -coords.y + (this.fMarkerHeight/2) - (coords.height/2), coords.z);
               plane.assetId = asset.id;
    
               return plane;
               
           }else{
               console.log("too late "+asset.sId+" "+asset.name)
               return null;
           }
       } */
}
